module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"no_item_message":{"none":"沒有評論。","filtered":"沒有符合條件的評論。"}}}')
  delete Component.options._Ctor
}
